import { lerp } from '@resn/gozer-math';
import { gsap } from '@resn/gsap';
import { createLogger } from '~/utils/logger';

const logger = createLogger('gl.cards-motion');

export const useCardsMotion = ({ object = null } = {}) => {
    if (!object) {
        return logger.warn('Required motion object missing', {
            event: 'argument.missing',
            argument: 'object',
            consumer: 'useCardsMotion',
        });
    }

    const createFanMotion = () => {
        const LABEL_DOWN = 1.2;

        const nCards = Math.max(object.children.length - 1, 1);

        const angleOffset = 0.1;
        const angleTotal = nCards * angleOffset;

        const depthMax = 0.8;

        const tl = gsap
            .timeline()
            .to(object.position, { y: -2, duration: 1.2, ease: 'power3.inOut' }, 0)
            .set(object.position, { y: 0, z: 0 }, LABEL_DOWN);

        object.children.forEach((_, i) => {
            const angle = angleTotal / 2 - i * angleOffset;

            const x = Math.sin(angle) * 1.2; // Circular position on x-axis
            const y = Math.cos(angle) * 0.1; // Circular position on y-axis
            const z = -((i * depthMax) / nCards);

            tl.set(_.rotation, { z: -angle / 2 }, LABEL_DOWN)
                .set(_.position, { y: -2, z }, LABEL_DOWN)
                .to(_.position, { x, y, duration: 1, ease: 'power2.out' }, LABEL_DOWN + i * 0.2);
        });

        return tl;
    };

    return {
        createFanMotion,
    };
};
